import {Presentation, PresentationState} from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import {WGParsedInitData} from "../../../server/data/WGParsedInitData";
import {ContinueButton} from "../ContinueButton";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {StageEvent} from "@nolimitcity/slot-game/bin/core/stage/event/StageEvent";
import {LayoutDimData, ResizeHelper} from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import {WarriorGraveyardGameModuleConfig} from "../../../WarriorGraveyardGameModuleConfig";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SpineTween} from "@nolimitcity/slot-game/bin/core/animation/SpineTween";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WGEngineManager} from "../../../engine/WGEngineManager";
import {ReelState} from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineController";
import {WildNudgePresentation} from "../nudge/WildNudgePresentation";
import {WGGameConfig} from "../../../WGGameConfig";
import {WGStillImageBackground} from "../../../background/WGStillImageBackground";
import {SoundManager} from "../../../resource/sound/SoundManager";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class RestorePresentation extends Presentation {
    private _introButton: ContinueButton;
    private _buttonShowed: boolean = false;
    private _introFrame: PIXI.spine.Spine;
    private introNumberSmashSpine: PIXI.Sprite;
    private _introBackground: PIXI.Sprite;
    private _graveyardSpinsText: PIXI.Sprite;
    private _freeSpinNumber: PIXI.Sprite;
    private _initData: WGParsedInitData;
    private _stickWildRestore: boolean = false;
    private _shouldActivate: boolean = false;

    public setParsedInitData(data: WGParsedInitData): void {
        this._initData = data;
        WGStillImageBackground._isSuperFreespin = data.superFreespin;
        WGGameConfig.CURRENT_GAME_MODE_BEFORE_SPIN_START = data.mode;
        this._shouldActivate = (data.freespinTriggeredThisSpin || this.checkForStickyWildResore(data));
        this.PresentationState.set(PresentationState.ACTIVATED);
    }

    private checkForStickyWildResore(data: WGParsedInitData): boolean {
        for (let i: number = 0; i < data.lockedFSWildMultiplier.length; i++) {
            if (data.lockedFSWildMultiplier[i] > -1) {
                this._stickWildRestore = true;
                return true;
            }
        }
        return false;
    }

    public initialization(): void {
        this.introNumberSmashSpine = new PIXI.Sprite(GameResources.getTextures("Animations/Intro_outro/i_crack")[0]);
        this.introNumberSmashSpine.anchor.set(0.5);
        this.introNumberSmashSpine.position.y = -255;
        this.introNumberSmashSpine.position.x = 13;

        // Background
        this._introBackground = new PIXI.Sprite(GameResources.getTextures("introBackground")[0]);
        this._introBackground.anchor.set(0.5);
        this._introBackground.position.y = -200;

        //graveyard spins text
        this._graveyardSpinsText = new PIXI.Sprite(GameResources.getTextures("graveyardSpinsText")[0]);
        this._graveyardSpinsText.anchor.set(0.5);
        this._graveyardSpinsText.position.y = -100;
        this._graveyardSpinsText.position.x = 10;

        // intro frame
        this._introFrame = new PIXI.spine.Spine(GameResources.getSpineAsset("intro_outro_spine"));
        this._introFrame.position.y = -200;

        // intro button
        this._introButton = new ContinueButton(() => {
            this.skipPresentation();
        });
        this._introButton.position.y += 100;
        this._introButton.position.x += 20;

        this._freeSpinNumber = new PIXI.Sprite(GameResources.getTextures("freeSpinText_8")[0]);
        this._freeSpinNumber.anchor.set(0.5);
        this._freeSpinNumber.position.y = -250;
        this._freeSpinNumber.position.x = 10;
        this.addChild(this._introBackground, this._introFrame, this.introNumberSmashSpine, this._introButton, this._freeSpinNumber, this._graveyardSpinsText);
        this.visible = false;
    }

    /**
     * event to call resize function
     */
    public addEventListeners(): void {
        EventHandler.addEventListener(this, StageEvent.STAGE_RESIZED, () => {
            this.onResize();
        });
    }

    /**
     * function to resize this.
     */
    public onResize(): void {
        const dimConf = ContinueButton.continueDim;
        let layoutdata: LayoutDimData = ResizeHelper.calcDim(dimConf);
        this.position = layoutdata.position;
        this.scale = layoutdata.scale;
    }

    public getPresentation(): void {
        this.PresentationState.set(PresentationState.INACTIVE);

        if (!this._shouldActivate) {
            this.pTimeline.to({}, 0.3, {});
            return;
        }
        if (this._stickWildRestore) {
            this.showStickWildOnFsReels();
            return;
        }
        if (this._buttonShowed) {
            return;
        }

        const textureName = this._initData.superFreespin ? "deathSpinsText" : "graveyardSpinsText";
        this._graveyardSpinsText.texture = GameResources.getTextures(textureName)[0];
        this._freeSpinNumber.texture = (GameResources.getTextures(`freeSpinText_${this._initData.freespinsLeft}`)[0]);
        const scale: number = this._initData.freespinsLeft > 8 ? 0.8 : 1;
        this._freeSpinNumber.scale.set(scale);
        const BgName: string = this._initData.superFreespin ? "outroBackground" : "introBackground";

        this._introBackground.texture = (GameResources.getTextures(BgName)[0]);

        this.visible = true;
        SlotGame.keypad.hide();

        const animName: string = this._initData.superFreespin ? "outro_restore" : "intro_loop"
        const smashTextureName = this._initData.superFreespin ? "Animations/Intro_outro/o_crack" : "Animations/Intro_outro/i_crack";

        this.introNumberSmashSpine.texture = GameResources.getTextures(smashTextureName)[0];
        new SpineTween(this._introFrame, 0, animName, -1);
        this._buttonShowed = true;
        this._introButton.visible = true;
        this.pTimeline.add(() => {
        }, 100000000000000);
    }

    private showStickWildOnFsReels(): void {
        for (let i: number = 1; i < 5; i++) {
            if (this._initData.lockedFSWildMultiplier[i] > -1) {
                WarriorGraveyardGameModuleConfig.stickWildView._lockedReels[i] = true;
                WGEngineManager.getReel(i).state.set(ReelState.IDLE);
                WarriorGraveyardGameModuleConfig.stickWildView._lockingWildAnimationOnReels[i - 1].visible = true;
                WarriorGraveyardGameModuleConfig.stickWildView._lockingWildAnimationOnReels[i - 1].setFrame(30);
                WarriorGraveyardGameModuleConfig.stickWildView._lockingCageContainer[i - 1].visible = true;
                WildNudgePresentation.showMulitplierOnRestore(i, this._initData.lockedFSWildMultiplier[i]);
            }
        }
    }

    /**
     * function to set timeline progress to 1 and calling stop from here.
     */
    public skipPresentation(): void {
        SoundManager.playFsLoop(this._initData.superFreespin); // to fix #287
        WGGameConfig.CURRENT_GAME_MODE_BEFORE_SPIN_START = this._initData.nextMode;
        this.pTimeline.totalProgress(1);
    }

    public stopPresentation(): void {
        if (!this._stickWildRestore) {
            WarriorGraveyardGameModuleConfig.stickMuliplier.showReelAreaMulitplier(this._initData.freespinMultiplier.toString());
            this._introButton.visible = false;
            this.visible = false;
            this._buttonShowed = false;
            EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode: "FREESPIN"}));
            if (this._initData.mode === GameMode.FREESPIN && !this._initData.superFreespin) {
                WarriorGraveyardGameModuleConfig.background.startFSBgRaining();
            }
        }
    }
}